import React, { memo } from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { FaAngleRight, FaAngleLeft } from 'react-icons/fa';

import { Box, Button, IconButton } from '@mui/material';

import PageSize from './PageSize';

const Pagination = ({
  pageIndex,
  pagesCount,
  hasPrevPage,
  hasPageSize,
  hasNextPage,
  handlePagSize,
  handleLastPage,
  handleNextPage,
  handlePrevPage,
  handleFirstPage,
  selectedPageSize,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      alignSelf="flex-start"
      bottom={0}
      justifyContent="space-between"
      marginTop={6}>
      <Box display="flex">
        <Button
          style={{ marginRight: 1, borderRadius: 0 }}
          disabled={hasPrevPage}
          onClick={handleFirstPage}>
          {t('First')}
        </Button>
        <IconButton
          rounded="0"
          icon={<FaAngleLeft />}
          aria-label="Next Page"
          disabled={hasPrevPage}
          onClick={handleNextPage}
        />
        <Box display="flex" alignItems="center" px={1}>
          {t('Page')} {pageIndex} {t('of')} {pagesCount || 1}
        </Box>
        <IconButton
          style={{ marginRight: 1, borderRadius: 0 }}
          icon={<FaAngleRight />}
          aria-label="Prev Page"
          disabled={hasNextPage}
          onClick={handlePrevPage}
        />
        <Button
          style={{ borderRadius: 0 }}
          disabled={hasNextPage}
          onClick={handleLastPage}>
          {t('Last')}
        </Button>
      </Box>
      {hasPageSize && (
        <PageSize
          handlePagSize={handlePagSize}
          selectedPageSize={selectedPageSize}
        />
      )}
    </Box>
  );
};

Pagination.defaultProps = {
  hasPageSize: false,
};

Pagination.propTypes = {
  hasPageSize: PropTypes.bool,
  pageIndex: PropTypes.number.isRequired,
  hasNextPage: PropTypes.bool.isRequired,
  hasPrevPage: PropTypes.bool.isRequired,
  pagesCount: PropTypes.number.isRequired,
  handlePagSize: PropTypes.func.isRequired,
  handleLastPage: PropTypes.func.isRequired,
  handleNextPage: PropTypes.func.isRequired,
  handlePrevPage: PropTypes.func.isRequired,
  handleFirstPage: PropTypes.func.isRequired,
  selectedPageSize: PropTypes.number.isRequired,
};

export default memo(Pagination);
